<template>
    <div class="items color">
        <ul
            id="colorList"
            class="d-flex flex-wrap list-unstyled mb-0"
            @mouseleave="resetPreviewImage"
        >
            <li
                v-for="variation in variationsToShow"
                :key="variation.variationId"
                @mouseenter="previewImage(variation.previewImage)"
            >
                <a
                    :href="langPrefix + variation.urlPath"
                    :class="{'sold': !variation.hasStock , 'active': variationId === variation.variationId }"
                    @click="setShowAllState"
                >
                    <mh-item-image :img-url="variation.previewImage"
                                   :alt="variation.name"
                                   :title="variation.name + (variation.hasStock ? '' : (' - ' + $translate('modeherz::SingleItemPageClient.itemPageSoldOut')))"
                                   lazy
                    />
                </a>
            </li>
        </ul>
        <button
            v-if="!opened && variationAttributes.length > preloadImageLimit"
            class="btn btn-outline-primary"
            @click="showMore"
        >
            {{ $translate("modeherz::SingleItemPageClient.itemPageShowMore") }}
        </button>
    </div>
</template>

<script>
    import { isBreakpointUp } from '../../../helpers/device-size-check';

    export default {
        name: 'VariationImageSelection',
        props: {
            variationAttributes: {
                type: Array,
                default: () => [],
            },
            variationId: {
                type: Number,
                required: true,
            },
            preloadImageLimit: {
                type: Number,
                default: 12,
            },
            lang: {
                type: String,
                required: true,
            },
        },
        data() {
            return {
                opened: false,
                originalImage: null,
                isLargeDevice: false,
                imageConversionEnabled: App.config.log.modernImagesConversion,
            };
        },
        computed: {
            variationsToShow() {
                if (this.opened) {
                    return this.variationAttributes;
                }
                return this.variationAttributes.slice(0, this.preloadImageLimit);
            },
            langPrefix() {
                return this.lang === App.defaultLanguage ? '' : ('/' + this.lang);
            },
        },
        mounted() {
            this.isLargeDevice = isBreakpointUp('md');
            try {
                if (window.localStorage) {
                    const opened = window.localStorage.getItem('item.variation.show-all');
                    const clickedOnVariationImageTile = window.localStorage.getItem('item.variation.clicked');
                    if (opened === 'true' && clickedOnVariationImageTile === 'true') {
                        this.showMore();
                    }
                    window.localStorage.setItem('item.variation.clicked', false + '');
                }
            } catch (e) {
                console.error('error with local storage', e);
            }
        },
        methods: {
            showMore() {
                this.opened = true;
                this.$nextTick(() => {
                    $('[data-toggle="tooltip"]').tooltip();
                });

            },
            previewImage(url) {
                if (!this.isLargeDevice) {
                    return;
                }
                const currentImage = document.querySelector('.mz-figure > img');
                if (!currentImage) {
                    return;
                }
                if (!this.originalImage) {
                    this.originalImage = currentImage.src;
                }
                currentImage.src = url.replace('/preview/', '/full/') + (this.imageConversionEnabled && App.features.avif ? '.avif' : '');
            },
            resetPreviewImage() {
                if (this.originalImage) {
                    document.querySelector('.mz-figure > img').src = this.originalImage;
                    this.originalImage = null;
                }
            },
            setShowAllState() {
                try {
                    if (window.localStorage) {
                        window.localStorage.setItem('item.variation.show-all', this.opened + '');
                        window.localStorage.setItem('item.variation.clicked', true + '');
                    }
                } catch (e) {
                    console.error('error with local storage', e);
                }
            },
        },
    };
</script>

<style scoped>

</style>
